import { useEffect } from 'react';

import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import { fullBuyEquipAnalyticsBase } from '~/src/analytics';
import CreditBanner from '~/src/features/work-in-home-ab/components/Description/components/TestDrive/components/Banner';

import CreditDetails from './components/Details';
import { SelectCreditOptionPopup } from './components/SelectCreditOptionPopup';
import { setIsShowDetails, setIsShowOptionSelect, setSelectedCreditCondition } from './context/actions';
import { useContextDispatch } from './context/hooks';
import { getBannerData, getSelectedCreditCondition } from './helpers';

export interface IProps {
    creditConditions: ICreditCondition[],
    onChangeOption: (optionId: string | number, variantId: string | number) => void,
    selectedOptionId: string | number,
    onOrder: () => void,
    dataLayerLabel: string,
}
const CreditWrapper = ({ creditConditions, onChangeOption, onOrder, selectedOptionId, dataLayerLabel }: IProps): JSX.Element => {
    const { title, description, image } = getBannerData();

    const dispatch = useContextDispatch();

    useEffect(() => {
        const selectedCreditCondition = getSelectedCreditCondition(creditConditions, selectedOptionId);
        if (selectedCreditCondition) {
            dispatch(setSelectedCreditCondition(selectedCreditCondition));
        }
    }, [creditConditions, selectedOptionId]);

    const onBannerClick = () => {
      fullBuyEquipAnalyticsBase.clickToBanner(dataLayerLabel);
      dispatch(setIsShowDetails(true));
    };

    const onHideSelect = () => {
        dispatch(setIsShowOptionSelect(false));
    };

    const onConfirmSelect = ({ payOption: { optionId, variantId } }: { payOption: { optionId: string, variantId: string | number } }) => {
        onChangeOption(optionId, variantId);
        const selectedCreditCondition = getSelectedCreditCondition(creditConditions, variantId);
        if (selectedCreditCondition) {
            dispatch(setSelectedCreditCondition(selectedCreditCondition));
        }
        onHideSelect();
    };

    return (
        <>
            <CreditBanner title={title} description={description} image={image} onBannerClick={onBannerClick} />
            <CreditDetails onOrder={onOrder}/>
            <SelectCreditOptionPopup
                creditConditions={creditConditions}
                onConfirmSelect={onConfirmSelect}
                onClose={onHideSelect}
            />
        </>
    );
};

export default CreditWrapper;
